<template>
  <tr 
    v-if="viewPort == 'large'"
    class="sm-customers-table__desktop-item"
  >
    <td class="registered sm-txt-nowrap">
      <span v-if="item.created_on">{{item.created_on | moment('MMM D, YYYY')}}</span>
    </td>
    <td class="pmb sm-txt-center">
      <span>{{item.pmb}}</span>
      <hint-wrap
        v-if="item.is_active && item.pmb"
        :text="'Fast mail entry'"
        :left="true"
      >
        <template slot="content">
          <a
            href="#"
            class="sm-customers-table__quick-mail"
            @click.prevent="quickMail"
          >
            <include-svg 
              :name="'icon-quick-mail'"
            />
          </a>
        </template>
      </hint-wrap>
    </td>
    <td class="username sm-txt-center">
      <a
        href="#"
        class="sm-link-blue"
        :class="{
          'disabled': item.id != userAccount.id && !checkHigherRole(userAccount.role, item.role)
        }"
        @click.prevent="openAccount(item.id)"
      >{{item.user_name}}</a>
    </td>
    <td class="name">
      <text-truncate :text="item.full_name" />
    </td>
    <td class="company">
      <text-truncate :text="item.company_name" />
    </td>
    <td class="">
      <text-copy 
        v-if="item.activation_code"
        :text="item.activation_code" 
      />
    </td>
    <td class="registered sm-txt-nowrap">
      <span v-if="item.registered_on">{{item.registered_on | moment('MMM D, YYYY')}}</span>
    </td>
    <td class="actions">
      <div 
        v-if="!item.is_privileged"
        class="sm-customers-table__desktop-item-actions"
      >
        <div class="sm-customers-table__desktop-item-actions-item">
          <a
            href="#"
            class="icon"
            @click.prevent="assignPMB"
          >
            <hint-wrap :text="`Assign Mailbox#`">
              <template slot="content">
                <include-svg :name="'icon-pmb'" />
              </template>
            </hint-wrap>
          </a>
        </div>
        <div 
          class="sm-customers-table__desktop-item-actions-item"
          @mouseenter="setHint(true)"
          @mouseleave="setHint(false)"
        >
          <a
            v-if="item.id != user.id"
            href="#"
            :class="{
              'icon': true,
              'disabled': !item.registered_on
            }"
            @click.prevent="loginAsCustomer"
          >
            <include-svg :name="'icon-action-customer'" />
          </a>
          <hint-block 
            v-if="showHint"
            :class="{
              'inactive': !item.registered_on
            }"
          >
            <template slot="hintContent">{{item.registered_on ? `Log in as ${item.full_name}` : `Can't log in as inactive user`}}</template>
          </hint-block>
        </div>        
      </div>
      <div 
        v-else
        class="sm-txt-capitalize sm-txt-right"
      >{{item.role.replace('_', ' ')}}</div>
    </td>
  </tr>
  <div
    v-else
    class="sm-mobile-table-item"
    :class="{
      'open': item.itemOpen
    }"
  >
    <div 
      class="sm-mobile-table-item-row"
      @click="toggleItem"
    >
      <div class="sm-mobile-table-item-row-elem name">
        <include-svg :name="'icon-arrow-b-bold'" />
        <a
          href="#"
          class="sm-link-blue"
          :class="{
            'disabled': item.id != userAccount.id && !checkHigherRole(userAccount.role, item.role)
          }"
          @click.stop="(e) => openAccount(item.id, e)"
        >
          <text-truncate :text="item.full_name" />
        </a>
      </div>
      <div class="sm-mobile-table-item-row-elem pmb sm-txt-center">
        <span>{{item.pmb}}</span>
        <a
          v-if="item.is_active && item.pmb"
          href="#"
          class="sm-customers-table__quick-mail"
          @click.prevent="quickMail"
        >
          <include-svg 
            :name="'icon-quick-mail'"
          />
        </a>
      </div>
      <div 
        v-if="viewPort == 'medium'"
        class="sm-mobile-table-item-row-elem username"
      >{{item.user_name}}</div>
      <div 
        v-if="viewPort == 'medium'"
        class="sm-mobile-table-item-row-elem activation-code"
      >
        <text-copy 
          v-if="item.activation_code"
          :text="item.activation_code" 
        />
      </div>
      <div
        class="sm-mobile-table-item-row-elem actions" 
        :class="{
          'disabled': item.is_privileged  
        }"
        @click="showPopup"
      >
        <a href="#"></a>
      </div>
    </div>
    <ul 
      class="sm-mobile-table-item-dropdown sm-customers-table__mobile-dropdown"
      :class="{'flex': viewPort == 'medium'}"
    >
      <li v-if="item.is_privileged">
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">User Role</span>
        <span class="sm-txt-capitalize">{{item.role.replace('_', ' ')}}</span>
      </li>
      <li v-if="viewPort == 'small'">
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Name</span>
        <span>{{item.full_name}}</span>
      </li>
      <li v-if="viewPort == 'small' && item.activation_code">
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Activation code</span>
        <span>
          <text-copy :text="item.activation_code" />
        </span>
      </li>
      <li v-if="item.company_name">
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Company</span>
        <span>{{item.company_name}}</span>
      </li>
      <li v-if="item.created_on">
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Created on</span>
        <span>{{item.created_on | moment('MMM D, YYYY')}}</span>
      </li>
      <li v-if="item.registered_on">
        <span class="sm-txt-capitalize sm-customers-table__mobile-dropdown-title">Registered</span>
        <span>{{item.registered_on | moment('MMM D, YYYY')}}</span>
      </li>
    </ul>
    <div
      class="sm-mobile-table-item-popup"
      v-if="item.popupOpen"
      v-click-outside="hidePopup"
    >
      <ul>
        <li>
          <a
            href="#"
            class="icon"
            @click.prevent="assignPMB"
          >Assign Mailbox#</a>
        </li>
        <li>
          <a
            v-if="item.id != user.id"
            href="#"
            :class="{
              'icon': true,
              'disabled': !item.registered_on
            }"
            @click.prevent="loginAsCustomer"
          >{{item.registered_on ? `Log in as ${item.full_name}` : `Can't log in as inactive user`}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HintWrap from '@/components/HintWrap';
import Hint from '@/components/Hint';
import {CheckHigherRole} from '@/utils/roles';
import vClickOutside from 'v-click-outside';
import Spinner from '@/components/Spinner';
import TextCopy from '@/components/TextCopy';

export default {
  name: 'customers-item-lvl1',
  components: {
    'hint-wrap': HintWrap,
    'hint-block': Hint,
    'sm-spinner': Spinner,
    'text-copy': TextCopy
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    viewPort: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showTerm: false,
      showRecipients: false,
      recipientsRequested: false,
      hintTimer: null,
      showHint: false
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      user: 'auth/user',
      userAccount: 'account/userAccount',
      provider: 'provider'
    }),
    showForm1583Warning() {
      return (
        !this.item.is_privileged &&
        this.item.hasOwnProperty('is_form_1583_signed') && 
        !this.item.is_form_1583_signed &&
        this.provider.country_id == 1
      )
    },
    showNoDocumentsWarning() {
      return (
        this.provider.country_id != 1 &&
        !this.item.is_privileged &&
        this.item.hasOwnProperty('account_approval_status') &&
        this.item.account_approval_status != 'approved'
      )
    },
    warning() {
      if (this.showForm1583Warning)
        return 'This user has not signed USPS Form 1583 yet';

      if (this.showNoDocumentsWarning)
        return this.item.required_documents_uploaded ? 'Documents waiting approval' : 'Account is not approved';

      return '';
    }
  },
  methods: {
    checkHigherRole: CheckHigherRole,
    toggleItem(e) {
      if (!e.target.classList.contains('actions'))
        this.item.itemOpen = !this.item.itemOpen;
    },
    assignPMB() {
      this.$emit('action', {
        name: 'pmb',
        id: this.item.id
      });
    },
    loginAsCustomer() {
      this.$emit('action', {
        name: 'login',
        id: this.item.id
      });
    },
    quickMail(e) {
      e.stopPropagation();

      this.$emit('action', {
        name: 'quick-mail',
        pmb: this.item.pmb
      });
    },
    showPopup() {
      this.item.popupOpen = true;
    },
    hidePopup() {
      this.item.popupOpen = false;
    },
    openAccount(id, e, documents) {
      if (id == this.userAccount.id) {
        this.$router.push('account');
      } else {
        this.$router.push(`customer/${id}${documents ? '?from=list' : ''}`);
      }

      if (e)
        e.preventDefault();
    },
    showRecipientsList() {
      this.hintTimer = setTimeout(() => this.showRecipients = true, 10);

      if (!this.recipientsRequested) {
        this.recipientsRequested = true;
        this.$emit('action', {
          name: 'recipients',
          customer: this.item
        });
      }
    },
    hideRecipientsList() {
      this.showRecipients = false;
      clearTimeout(this.hintTimer);
    },
    setHint(val) {
      setTimeout(() => {
        this.showHint = val;
      }, 100);
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
}
</script>